import {React,useState} from "react";
import { Form, Input, Button, Row, Col } from "antd";
import { useNavigate } from "react-router-dom";

function LandingZoneFormPage(){
    const [form] = Form.useForm();

    const [state, setState] = useState({
        version: "",
        governedregions: "",
        securityouname: "",
        sandboxouname: "",
        loggingaccountid: "",
        securityaccountid: "",
        loggingbucketretentionperiod: "",
        accessloggingBucketretentionperiod: "",
        kmskey: "",
      });
      
      const handleInputChange = (event) => {
        const { name, value } = event.target;
        setState((prevProps) => ({
          ...prevProps,
          [name]: value,
        }));
      };

 
      

      const handleSubmit = (event) => {
        event.preventDefault();
        console.log(state);
      };

      const navigate = useNavigate();

      function HandleOpen() {
        navigate("/landingzoneform");
      }

      const HandleSave = () => {
        form.validateFields().then(() => {
          navigate("/landingzone");
        }).catch((errorInfo) => {
          console.log("Form validation failed:", errorInfo);
        });
      };

    return(
        <>

         <Form onSubmit={handleSubmit} form={form}>
<div className="landingzoneadd1">
    <Row gutter={[16, 16]} className="d-flex justify-content-center">
      <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">Version</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="version"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1"  placeholder="Enter version" value={state.version} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">GovernedRegions</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="governedregions"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter governedregions" value={state.governedregions} onChange={handleInputChange}/>
      
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={24}>
            <span className="devops-form-names2">
            Security OuName
            </span>
          </Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="securityouname"
              rules={[{ required: true, message: "Required" }]}
            >


<Input type="text" className="devops-antd-select1" 
placeholder="Enter securityouname" value={state.securityouname} 
onChange={handleInputChange} name="securityouname"/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            Sandbox OuName
            </span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="sandboxouname"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  sandboxouname" value={state.sandboxouname} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            Logging AccountId
            </span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="loggingaccountid"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  loggingaccountid" value={state.loggingaccountid} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            Security AccountId
            </span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="securityaccountid"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  securityaccountid" value={state.securityaccountid} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            LoggingBucketRetentionPeriod</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="loggingbucketretentionperiod"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  loggingbucketretentionperiod" value={state.loggingbucketretentionperiod} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            AccessLoggingBucketRetentionPeriod</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="accessloggingBucketretentionperiod"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  accessloggingBucketretentionperiod" value={state.accessloggingBucketretentionperiod} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={24}>
            <span className="devops-form-names2">
            KMSKey</span>
          </Col>
          <Col xxl={1} xl={1} lg={1} md={1} sm={1}></Col>
          <Col xxl={18} xl={18} lg={18} md={18} sm={24}>
            <Form.Item
              name="kmskey"
              rules={[{ required: true, message: "Required" }]}
            >
            <Input type="text" className="devops-antd-select1" placeholder="Enter  kmskey" value={state.kmskey} onChange={handleInputChange}/>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
  <br />
  <div className="SaveBack">
  <Row gutter={[16, 16]} justify="end">
    <Col span={24}>
      <Form.Item style={{ textAlign: "right" }}>
        <Button
          className="form-back-button"
          htmlType="button"
          onClick={HandleOpen}

        >
          Back
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          className="form-button save-form-button"
          onClick={HandleSave}
        >
          Save
        </Button>
        </Form.Item>
      </Col>
    </Row>
    </div>
  </Form>
        </>
    )

}
export default LandingZoneFormPage;